<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <NavigationBar v-if="!$route.meta.keepAlive" />
    <router-view v-if="isRouterAlive" />
    <common-footer v-if="!$route.meta.footerkeepAlive"></common-footer>
  </div>
</template>

<script>
import NavigationBar from "@/views/NavigationBar.vue";

import CommonFooter from "@/views/Foot.vue";

export default {
  components: {
    NavigationBar: NavigationBar,
    CommonFooter,
  },

  provide() {
    return {
      reload: this.reload,
    };
  },

  mounted() {},

  data() {
    return {
      isRouterAlive: true,
    };
  },

  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>

<style lang="stylus">
.qujian .el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

// 去除各个浏览器的默认空白样式
body, div, dl, dt, dd, ul, ol, li, h1, h2, h4, h5, h6, pre, form, fieldset, input, textarea, p, blockquote, th, td {
  margin: 0;
  padding: 0;
  // font-family: mFont;
}

// @font-face {
// font-family: mFont;
// src: url('./assets/font/msyh.ttf');
// }
ul, li {
  list-style: none;
}
</style>
